import { AppConstants, Interfaces } from "@/core/Export";
import DataSource from "devextreme/data/data_source";
import store from "@/store";
import "devextreme/data/odata/store";

class Odata {
  private _token: string = null;
  private _accessToken: string = null;

  public getDSByName(name: string) {
    if (!name) return null;
    var params = name.split(".");
    var func = this[params[0]];
    var prm = "";
    if (params.length > 1) {
      prm = params[1];
    }
    return func(prm, this);
  }

  // public ActivityLog() {
  //   return new DataSource({
  //     store: {
  //       type: "odata",
  //       url: AppConstants.Http.BaseODataUrl + "ActivityLogOdata",
  //       version: 4,
  //       beforeSend: e => {
  //         e.headers = this.getHeaders();
  //       },
  //       errorHandler: error => {
  //         if(error.__id =='E4018')
  //         this.appEnv.showErrorDialog([{ message: "משתמש לא מאומת" }]);
  //       }
  //     },
  //     paginate: true
  //   });
  // }

  // public PersonYearMin() {
  //   return new DataSource({
  //     store: {
  //       type: "odata",
  //       url: AppConstants.Http.BaseODataUrl + "PersonYearOdata",
  //       version: 4,
  //       beforeSend: e => {
  //         e.headers = this.getHeaders();
  //       },
  //       errorHandler: error => {
  //         if(error.__id =='E4018')
  //         this.appEnv.showErrorDialog([{ message: "משתמש לא מאומת" }]);
  //       }
  //     }
  //   });
  // }

  // public Request() {
  //   return new DataSource({
  //     store: {
  //       type: "odata",
  //       url: AppConstants.Http.BaseODataUrl + "RequestOdata",
  //       version: 4,
  //       beforeSend: e => {
  //         e.headers = this.getHeaders();
  //       },
  //       errorHandler: error => {
  //         if(error.__id =='E4018')
  //         this.appEnv.showErrorDialog([{ message: "משתמש לא מאומת" }]);        }
  //     }
  //   });
  // }

  private getHeaders() {
    return {
      "X-Requested-With": "Fetch",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json",
      accesstoken: this._accessToken,
      authorization: "Bearer " + this._token
    };
  }

  setHeaders(jwtToken: string, accessToken: string) {
    if (jwtToken) {
      this._token = jwtToken;
    }

    if (accessToken) {
      this._accessToken = accessToken;
    }
  }

  get appEnv() {
    return store.state.appEnv;
  }
}

export const odata = new Odata();
